import Notification from '../molecules/Notification';
import { styled } from '@mui/material/styles';
import { NotificationCenterContext } from '../types';
import LoaderSkeleton from '../molecules/LoaderSkeleton';

export type NotificationDashboardProps = {
  notificationCenterContext: NotificationCenterContext;
};

const NotificationDashboard = ({ notificationCenterContext }: NotificationDashboardProps) => {
  if (notificationCenterContext.notificationsLoading) {
    return <LoaderSkeleton width={750} height={90} label={''} />;
  }

  const notificationToDisplay = notificationCenterContext.notifications
    ?.filter((n) => n.read !== true)
    .sort((a, b) => b.createdAt - a.createdAt)
    .slice(0, 1);

  if (!notificationToDisplay || notificationToDisplay.length === 0) {
    return <></>;
  }

  return (
    <Div key={notificationToDisplay[0].id}>
      <Notification
        notification={notificationToDisplay[0]}
        onRead={notificationCenterContext.notificationsRead}
        variant={'outlined'}
      />
    </Div>
  );
};

const Div = styled('div')(
  () => `
  margin-bottom: 15px;
  margin-top: 5px;
`,
);

export default NotificationDashboard;
export { NotificationDashboard };
